import { MutationTree } from 'vuex'
import { PuntosPeligroState, StoreError } from '@/store/modules/puntos-peligro/types'

export const mutations: MutationTree<PuntosPeligroState> = {
  PUNTO_PELIGRO_FETCHED (state, payload: PuntosPeligroState) {
    state.error = { state: false }
    state.punto_peligro_list = payload.punto_peligro_list
    state.isLoaded = true
  },
  PUNTOS_PELIGRO_ERROR (state, payload: StoreError) {
    state.error = payload
  }
}
